import style from "../../assets/scss/common/header.module.scss";
import downloadIcon from "../../assets/images/header/download_icon.svg";
import loginIcon from "../../assets/images/header/login_icon.svg";
import expandedIcon from "../../assets/images/header/expanded_icon.svg";
import collapsedIcon from "../../assets/images/header/collapsed_icon.svg";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector, useAuth, useModal, useUserAgent } from "../../hooks/hooks";
import { VoucherCount } from "../../types/voucher";
import { getOrganVoucherCountAsync, getUserVoucherCountAsync } from "../../store/voucher/voucherSlice";
import { CouponCount } from "../../types/coupon";
import { getUserCouponCountAsync, setUserCouponCount, userCouponCountState } from "../../store/coupon/couponSlice";
import { ModalType } from "../../types/common";
import { CouponVoucherStatus } from "./CouponVoucherStatus";
import { useClickEvent } from "../../hooks/useClickEvent";
import { useUserInfoGetter } from "./hooks/useUserInfoGetter";

interface Props {
  signOut: VoidFunction;
}

export function LoginBar({ signOut }: Props) {
  const dispatch = useAppDispatch();

  const [userVoucherCount, setUserVoucherCount] = useState(0);
  const [organVoucherCount, setOrganVoucherCount] = useState(0);
  const userCouponCount = useAppSelector(userCouponCountState);
  const [isCouponVoucherCollapsed, setIsCouponVoucherCollapsed] = useState(true);

  const { isLoggedIn } = useAuth();
  const { openModal } = useModal();
  const { isDesktop } = useUserAgent();
  const { getUserInfo, user } = useUserInfoGetter();

  const onClickAppDownload = (e: React.MouseEvent) => {
    openModal(ModalType.APP_DOWNLOAD);
    e.stopPropagation();
  };
  const onClickLoginBtn = (e: React.MouseEvent) => {
    openModal(ModalType.LOGIN);
    e.stopPropagation();
  };

  const onClickLogoutBtn = () => signOut();

  const getUserVoucherCount = useCallback(async () => {
    try {
      const { count }: VoucherCount = await dispatch(getUserVoucherCountAsync()).unwrap();
      setUserVoucherCount(count);
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const getOrganVoucherCount = useCallback(async () => {
    try {
      const { count }: VoucherCount = await dispatch(getOrganVoucherCountAsync()).unwrap();
      setOrganVoucherCount(count);
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  const getCouponCount = useCallback(async () => {
    try {
      const { count }: CouponCount = await dispatch(getUserCouponCountAsync()).unwrap();
      dispatch(setUserCouponCount(count));
    } catch (error) {
      console.error(error);
    }
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn) {
      if (!user) {
        getUserInfo().then();
      }
      getUserVoucherCount().then();
      getOrganVoucherCount().then();
      getCouponCount().then();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn, user]);

  const LoginBtn = () => (
    <>
      <button className={style.loginBtn} onClick={onClickLoginBtn}>
        <img className={style.icon} src={loginIcon} alt="login-icon" />
        <span className={style.text}>로그인</span>
      </button>
    </>
  );

  const couponVoucherOptionsRef = useRef(null);
  useClickEvent({ elementRefs: [couponVoucherOptionsRef], doOnClickBg: () => setIsCouponVoucherCollapsed(true) });

  const LoggedInContent = () => (
    <div className={style.loggedInStatus}>
      {isDesktop ? (
        <CouponVoucherStatus
          couponCount={userCouponCount}
          organVoucherCount={organVoucherCount}
          userVoucherCount={userVoucherCount}
        />
      ) : (
        <></>
      )}
      {isDesktop ? (
        <>
          <span className={style.userName}>
            <span className={style.accent}>{user?.name}</span>님
          </span>
        </>
      ) : (
        <div className={style.myInfoWrapper}>
          <span className={style.userName}>
            <span className={style.accent}>{user?.name}</span>님
          </span>
          <div className={style.voucherCouponButtonWrapper}>
            <button
              className={style.voucherCouponButton}
              onClick={(e) => {
                e.stopPropagation();
                setIsCouponVoucherCollapsed(!isCouponVoucherCollapsed);
              }}
            >
              <span>쿠폰·이용권</span>
              <img src={isCouponVoucherCollapsed ? collapsedIcon : expandedIcon} alt={"펼침 아이콘"} />
            </button>
            {isCouponVoucherCollapsed ? (
              <></>
            ) : (
              <div ref={couponVoucherOptionsRef}>
                <CouponVoucherStatus
                  couponCount={userCouponCount}
                  organVoucherCount={organVoucherCount}
                  userVoucherCount={userVoucherCount}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <button className={style.logoutBtn} onClick={onClickLogoutBtn}>
        로그아웃
      </button>
    </div>
  );

  return (
    <>
      <div className={style.loginBar}>
        <div className={style.innerBar}>
          {!isLoggedIn ? (
            <div className={style.downloadNotice}>
              <span className={style.text}>
                {isDesktop ? (
                  <>
                    <span className={style.accent}>K-PASS with 앱</span> 에서 회원가입 해주세요!
                  </>
                ) : (
                  <>
                    <span className={style.accent}>K-PASS with 앱</span> 회원가입
                  </>
                )}
              </span>
              <span className={style.downloadText} onClick={onClickAppDownload}>
                앱 다운로드
                <img src={downloadIcon} alt="download-icon" />
              </span>
            </div>
          ) : (
            <div></div>
          )}
          {isLoggedIn ? <LoggedInContent /> : <LoginBtn />}
        </div>
      </div>
    </>
  );
}
